module.exports = __webpack_public_path__ + "static/media/tone-arm.90ef8386.svg";